<div class="layout-footer flex justify-content-between align-items-center">
    <div class="logo-text">
        <div style="cursor: pointer;" (click)="labportalLink()">
            <img src="assets/layout/images/logo/logo.png" alt="Vetportal" style="height: auto; width: 100px" />
        </div>
    </div>

    <div class="text ml-2">
        <a class="version-link mr-3" (click)="labportalVersion()">Version:
            1.26.0</a> <span>Rel. Date:
            Aug 18, 2026</span>
    </div>
</div>